import Sidebar from './Sidebar';
import { useAuth } from '../../context/AuthContext';

export default function DashboardLayout({ children, title, subtitle }) {
  const { user } = useAuth();
  return (
    <div className="dashboard-layout">
      <Sidebar role={user?.role} />
      <main className="dashboard-main">
        <div className="dashboard-topbar">
          <div>
            {title && <h1 style={{fontSize:'1.1rem',fontWeight:700,margin:0}}>{title}</h1>}
            {subtitle && <p style={{fontSize:'0.78rem',color:'var(--ink-400)',margin:0}}>{subtitle}</p>}
          </div>
          <div style={{display:'flex',alignItems:'center',gap:12}}>
            <span style={{fontSize:'0.8rem',color:'var(--ink-400)',fontWeight:500}}>
              {user?.currency === 'USD' ? '🇺🇸 USD' : '🇬🇧 GBP'}
            </span>
            <div className="avatar-placeholder avatar-sm" style={{fontSize:'0.75rem'}}>
              {user?.first_name?.[0]}{user?.last_name?.[0]}
            </div>
          </div>
        </div>
        <div className="dashboard-page">
          {children}
        </div>
      </main>
    </div>
  );
}
